"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var React = require("react");
var react_select_1 = require("react-select");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Icon_1 = require("components/Icon");
var Container = function (props) {
    var subText1 = (0, translation_1.getLocalization)('userfront/project/ScheduledDeletion/text1');
    var subText2 = (0, translation_1.getLocalization)('userfront/project/ScheduledDeletion/text2');
    var periods = ['days', 'weeks', 'months', 'years'].map(function (id) { return ({
        id: id,
        name: "userfront/project/ScheduledDeletion/".concat(id)
    }); });
    return (React.createElement(sok_ui_1.Container, null,
        React.createElement("div", { className: "loading-spinner" }, props.status !== 'FETCHED' && (React.createElement(sok_ui_1.RequestSpinner, { isLoading: props.status === 'FETCHING', success: false }))),
        (function () {
            if (props.status === 'FAILURE') {
                return React.createElement("div", null);
            }
            if (props.status === 'FETCHED') {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'text' },
                        React.createElement("p", null, subText1),
                        React.createElement("p", null, subText2)),
                    React.createElement("div", { className: 'form' },
                        React.createElement("h4", null, (0, translation_1.getLocalization)('userfront/project/ScheduledDeletion/title')),
                        React.createElement("div", { className: 'fields' },
                            React.createElement(sok_ui_1.TextInput, { id: 'timeframe', type: 'number', className: 'white meta-modal-input', value: props.retentionTime || '', onChange: function (_a) {
                                    var value = _a.target.value;
                                    if (value !== null) {
                                        var parsed = parseInt(value, 10);
                                        if (!isNaN(parsed)) {
                                            props.setRetentionTime(parsed);
                                            return;
                                        }
                                    }
                                    props.setRetentionTime(null);
                                } }),
                            React.createElement(react_select_1.default, { menuPlacement: 'auto', classNamePrefix: 'react-select', id: 'period', value: props.retentionTimeUnits !== undefined &&
                                    periods.find(function (x) { return x.id === props.retentionTimeUnits; }), options: periods, isSearchable: false, getOptionValue: function (opt) { return opt.id; }, getOptionLabel: function (opt) { return (0, translation_1.getLocalization)(opt.name); }, onChange: function (e) {
                                    props.setRetentionTimeUnits(e.id);
                                } }))),
                    !props.isInputValid && (React.createElement("div", { className: 'error-message' }, (0, translation_1.getLocalization)('userfront/project/ScheduledDeletion/error'))),
                    React.createElement("div", null,
                        React.createElement(sok_ui_1.Button, { color: 'dark-gray', iconRight: React.createElement(Icon_1.Icon, { className: 'fa-eraser' }), text: (0, translation_1.getLocalization)('userfront/project/ScheduledDeletion/reset'), onClick: function () {
                                props.setRetentionTime(null);
                                props.setRetentionTimeUnits(undefined);
                            } }))));
            }
        })()));
};
exports.Container = Container;
